(function() {
    'use strict';
    angular.module('cabinFlightAdmin').controller('editCabinFlightPopupCtrl', editCabinFlightPopupCtrl);

    function editCabinFlightPopupCtrl($timeout,$uibModalInstance, modalParams, MessageService, EventManagerService, PopupManager, CommonMasterData,RemoteService,
    		cabinFlightAdminService, applicationConstants) {

    	var vm = this;
        vm.cabinFlightVersion = modalParams.cabinFlightVersion;
        vm.cabinFlightReportId = modalParams.cabinFlightReportId;
        vm.crewSchdBlockId = modalParams.crewSchdBlockId;
        vm.feedbackRequiredInCabinFlightApproval = modalParams.feedbackRequiredInCabinFlightApproval;
        vm.aircraftModel = modalParams.aircraftModel;
        vm.crewPositions = modalParams.crewPositions;
        vm.editCabinFlightData = "outbound";

        vm.inBoundData = {
            flightPunctualityOpen: true,
            specialServicesOpen: false,
            remarksOpen: false
        };
        vm.outBoundData = {
            flightPunctualityOpen: true,
            specialServicesOpen: true,
            cateringOpen: false,
            remarksOpen: true
        };
        vm.model = {
            departmentList: [],
            flightTypes: [],
            delayCodes: [],
            emailRecipients: null,
            sno1Required :false,
            sno2Required:false,
            sno1 :null,
            sno2 :null
        };

      vm.intermediateData = {
        flightPunctualityOpen: true,
        specialServicesOpen: false,
        remarksOpen: false
      };

        vm.dutyTabData = {};
        vm.flightReportsTabData = {};
        vm.specialRemarksTabData = [];
        vm.filteredSpecialRemarksTabData = [];
        vm.specialRemarksList = [];
        vm.outBoundCrewCollection = [];
        vm.inBoundCrewCollection = [];
        vm.intBoundCrewCollection = [];
        vm.outboundCPCrews = [];
        vm.outboundFOCrews = [];
        vm.outboundCCCSCrews = [];
        vm.inboundCCCSCrews = [];
        vm.outboundENCrews = [];
        vm.allOutboundCrewsInboundCCCScrews = [];
        vm.inboundFOCrews = [];
        vm.inboundSOCrews = [];
        vm.allOutboundCrewsInboundCPcrews = [];
        vm.crewBaseEdit = null;

        vm.selectedRemark={};

        vm.copiedCrewId = null;

        loadPaneldata();
        getCrewBase();

        function loadPaneldata() {
        	cabinFlightAdminService.getDepartments(function(departments) {
                vm.model.departmentList = departments.deparmentDTOs;
                vm.model.departments = angular.copy(departments.deparmentDTOs);
                var allType = {

                		code: null,
                		description: 'All'
                };
                vm.model.departmentList.unshift(allType);
                vm.filterByDepartment = vm.model.departmentList[0];
            }, function(error) {
                if (error.msg) error = error.msg[0]
                console.log(error);
                MessageService.error(error);
            });

          cabinFlightAdminService.getCabinFlights(function(flights) {
                vm.model.flightTypes = flights.cabinFlightTypesList;
                vm.model.flights = angular.copy(flights.cabinFlightTypesList);
                var allType = {

                		cabinFlightTypeCode: null,
                		cabinFlightTypeDesc: 'All'
                };
                vm.model.flightTypes.unshift(allType);
                vm.filterByFlightType = vm.model.flightTypes[0];
            }, function(error) {
                if (error.msg) error = error.msg[0]
                console.log(error);
                MessageService.error(error);
            });

          CommonMasterData.getCabinFlightDelayCodes(function(delayData) {
                vm.model.delayCodes = delayData.delayCodeAdaptDTOs;
            }, function(error) {
                if (error.msg) error = error.msg[0]
                MessageService.error(error);
            });

          loadEditPanelData();
        }

        vm.swichView = function(flag ,index) {
            vm.editCabinFlightData = flag;

            if (flag === 'outbound') {
                vm.outBoundData = {
                    flightPunctualityOpen: true,
                    specialServicesOpen: true,
                    cateringOpen: false,
                    remarksOpen: true
                };
            }
            else if (flag === 'inbound') {
                vm.inBoundData = {
                    flightPunctualityOpen: true,
                    cateringOpen: false,
                    specialServicesOpen: true,
                    remarksOpen: true
                };
            }
            else if (flag ==='intermediate'){
              vm.editCabinFlightData =index;
              vm.intermediateData = {
                flightPunctualityOpen: true,
                specialServicesOpen: true,
                cateringOpen: false,
                remarksOpen: true
              };
            }
        };

        vm.clickOnAccordion = function(flag, selectedItem) {
            if (flag === 'outbound') {
                vm.outBoundData[selectedItem] = !vm.outBoundData[selectedItem];
            } else if (flag === 'inbound') {
                vm.inBoundData[selectedItem] = !vm.outBoundData[selectedItem];

            } else if (flag === 'intermediate') {
              vm.intermediateData[selectedItem] = !vm.outBoundData[selectedItem];

            }
        };

        vm.onCloseClick = function() {
            PopupManager.closeModal('EDIT_CABIN_FLIGHT_DETAILS');
        };

        function loadEditPanelData() {
            var param = {
                "cabinFlightVersion": vm.cabinFlightVersion,
                "cabinFlightReportId": vm.cabinFlightReportId,
                "crewSchdBlockId": vm.crewSchdBlockId
            };

            cabinFlightAdminService.getEditFlightPopUpDetails(param, function(response) {
                vm.flightReportsTabData = response.flightReportsTabData;
                vm.specialRemarksTabData = angular.copy(response.specialRemarksTabData);
                vm.specialRemarksList = adaptSpecialRemarksToSaveReqFormat(angular.copy(response.specialRemarksTabData));
                vm.filteredSpecialRemarksTabData = angular.copy(response.specialRemarksTabData);
                vm.dutyTabData = angular.copy(response.dutyTabData);
                vm.outBoundCrewCollection = angular.copy(response.outBoundCrewCollection);
                vm.inBoundCrewCollection = angular.copy(response.inBoundCrewCollection);
                vm.intBoundCrewCollection = angular.copy(response.intBoundCrewCollection);

                if(!response.flightReportsTabData.outBoundOrigin){
                  vm.editCabinFlightData = 'inbound';
                }

                if (vm.flightReportsTabData.inBoundInfoCollection) {
                	vm.flightReportsTabData.inBoundInfoCollection.remarks_copy = angular.copy(vm.flightReportsTabData.inBoundInfoCollection.remarks);
                }

                if (vm.flightReportsTabData.outBoundInfoCollection) {
                	vm.flightReportsTabData.outBoundInfoCollection.remarks_copy = angular.copy(vm.flightReportsTabData.outBoundInfoCollection.remarks);
                }

                if (vm.flightReportsTabData.intGroundInfoCollection) {
                  vm.flightReportsTabData.intGroundInfoCollection.remarks_copy = angular.copy(vm.flightReportsTabData.intGroundInfoCollection.remarks);
                }

                adaptDelayCodesToObject();

                loadCrewRoles();

            }, function(error) {
                MessageService.error(error.msg[0]);
                PopupManager.closeModal('EDIT_CABIN_FLIGHT_DETAILS');
            })
        }

        function adaptDelayCodesToObject() {
        	if (vm.flightReportsTabData.outBoundInfoCollection && vm.flightReportsTabData.outBoundInfoCollection.cabinFlightDelayCollection) {
                angular.forEach(vm.flightReportsTabData.outBoundInfoCollection.cabinFlightDelayCollection, function(reason) {
                    angular.forEach(vm.model.delayCodes, function(dealy) {
                        if (reason.delayCode == dealy.delayCode) {
                            reason.delayCode = dealy;
                        }
                    });
                });
            }

          if (vm.flightReportsTabData.inBoundInfoCollection && vm.flightReportsTabData.inBoundInfoCollection.cabinFlightDelayCollection) {
            angular.forEach(vm.flightReportsTabData.inBoundInfoCollection.cabinFlightDelayCollection, function(reason) {
              angular.forEach(vm.model.delayCodes, function(dealy) {
                if (reason.delayCode == dealy.delayCode) {
                  reason.delayCode = dealy;
                }
              });
            });
          }

          angular.forEach(vm.flightReportsTabData.intGroundInfoCollection, function (intermediateFlights) {
            if (intermediateFlights && intermediateFlights.cabinFlightDelayCollection) {
              angular.forEach(intermediateFlights.cabinFlightDelayCollection, function(reason) {
                angular.forEach(vm.model.delayCodes, function(dealy) {
                  if (reason.delayCode == dealy.delayCode) {
                    reason.delayCode = dealy;
                  }
                });
              });
            }
          })

        }

        vm.onApproveClick = function() {
        	if((!!vm.cabinFlightVersion || vm.cabinFlightVersion == 0) && !!vm.cabinFlightReportId && !!vm.crewSchdBlockId){
        		var approveCabinData = {
        				"cabinFlightVersion": vm.cabinFlightVersion,
        				"cabinFlightReportId": vm.cabinFlightReportId,
        				"crewSchdBlockId": vm.crewSchdBlockId,
                "feedbackRequiredInCabinFlightApproval": vm.feedbackRequiredInCabinFlightApproval
        		};

            if(vm.feedbackRequiredInCabinFlightApproval){ // feedback required
              approveCabinData.title = 'Confirmation';
              approveCabinData.messages = [MessageService.MESSAGES.CABIN_FLIGHT_ADMIN.APPROVE_CONFIRMATION]
              PopupManager.openModal('APPROVE_CABIN_FLIGHT_DETAILS', approveCabinData, closeModal);
            } else {
              approveCabinFlight(approveCabinData);
            }
        	}
        };

        function closeModal(isSuccess) {
          if (isSuccess) {
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.FLIGHT_REPORT.CABIN_FLIGHT_RPT_EDIT, isSuccess);
            vm.onCloseClick();
          }
        }

        function approveCabinFlight(approveCabinData) {
          var param = {
            "cabinFlightVersion": approveCabinData.cabinFlightVersion,
            "cabinFlightReportId": approveCabinData.cabinFlightReportId,
            "crewSchdBlockId": approveCabinData.crewSchdBlockId,
            "feedback": ""
          };
          cabinFlightAdminService.approveCabinFlight(param, function(response) {
            if (response.success) {
              MessageService.success(MessageService.MESSAGES.CABIN_FLIGHT_ADMIN.APPROVE_SUCCESS);

              EventManagerService.notifyEventListeners(EventManagerService.EVENT.FLIGHT_REPORT.CABIN_FLIGHT_RPT_EDIT, response.success);
              vm.onCloseClick();
            }
          }, function(error) {
            if (error) error = error.msg[0];
            MessageService.error(error);
          });
        }

        vm.filterInputData = function (event) {
          var keyCode = (event.which) ? event.which : event.keyCode;
          if(keyCode >= 47 && keyCode <= 57){
            return true;
          } else {
            event.preventDefault();
            return false;
          }
        };

      vm.onSaveClick = function () {
        if(validateTargetSales()) {

          if (vm.flightReportsTabData.outBoundInfoCollection) {
            vm.delayReasonslist = [];
            angular.forEach(vm.flightReportsTabData.outBoundInfoCollection.cabinFlightDelayCollection, function (reason, index) {
              if (reason.delayCode && reason.delayMinutes) {
                reason.delayCode = reason.delayCode.delayCode;
                vm.delayReasonslist.push(reason);
              }
            });
            vm.flightReportsTabData.outBoundInfoCollection.cabinFlightDelayCollection = angular.copy(vm.delayReasonslist);
          }

          if (vm.flightReportsTabData.inBoundInfoCollection) {
            vm.delayReasonslist1 = [];
            angular.forEach(vm.flightReportsTabData.inBoundInfoCollection.cabinFlightDelayCollection, function (reason1, index) {
              if (reason1.delayCode && reason1.delayMinutes) {
                reason1.delayCode = reason1.delayCode.delayCode;
                vm.delayReasonslist1.push(reason1);
              }
            });
            vm.flightReportsTabData.inBoundInfoCollection.cabinFlightDelayCollection = angular.copy(vm.delayReasonslist1);
          }

          angular.forEach(vm.flightReportsTabData.intGroundInfoCollection, function (intermediateFlights) {
            if (intermediateFlights) {
              vm.delayReasonslist2 = [];
              angular.forEach(intermediateFlights.cabinFlightDelayCollection, function (reason2, index) {
                if (reason2.delayCode && reason2.delayMinutes) {
                  reason2.delayCode = reason2.delayCode.delayCode;
                  vm.delayReasonslist2.push(reason2);
                }
              });
              intermediateFlights.cabinFlightDelayCollection = angular.copy(vm.delayReasonslist2);
            }
          });

          var param = {
            "cabinFlightVersion": vm.cabinFlightVersion,
            "cabinFlightReportId": vm.cabinFlightReportId,
            "crewSchdBlockId": vm.crewSchdBlockId,
            "aircraftModel": vm.aircraftModel,
            "crewPositions": vm.crewPositions,
            "dutyTabData": vm.dutyTabData,
            "flightReportsTabData": vm.flightReportsTabData,
            "specialRemarksTabData": adaptSpecialRemarksToSaveReqFormat(vm.filteredSpecialRemarksTabData)
          };

          cabinFlightAdminService.saveOrUpdateCabinFlight(param, function (response) {
            if (response.success) {
              MessageService.success("Saved successfully");
              $uibModalInstance.close({
                isSuccess: response.success
              });
              EventManagerService.notifyEventListeners(EventManagerService.EVENT.FLIGHT_REPORT.CABIN_FLIGHT_RPT_EDIT, response.success);
              // PopupManager.closeModal('EDIT_CABIN_FLIGHT_DETAILS');
            } else {
              adaptDelayCodesToObject();
            }
          }, function (error) {
            if (error.msg) error = error.msg[0];
            MessageService.error(error);
            adaptDelayCodesToObject();
          })

          }
        }

        vm.filterSpecialRemarks = function() {

            vm.filteredSpecialRemarksTabData = [];

            if (!vm.filterByFlightType.cabinFlightTypeCode && !vm.filterByDepartment.code) {
            	vm.filteredSpecialRemarksTabData = vm.specialRemarksTabData;
            }
            else if(!vm.filterByFlightType.cabinFlightTypeCode && vm.filterByDepartment.code){
            	angular.forEach(vm.specialRemarksTabData, function(data) {
                    if (vm.filterByDepartment.code == data.department) {
                    	vm.filteredSpecialRemarksTabData.push(data);
                    }
                });
            }
            else if(vm.filterByFlightType.cabinFlightTypeCode && !vm.filterByDepartment.code){
            	angular.forEach(vm.specialRemarksTabData, function(data) {
                    if (vm.filterByFlightType.cabinFlightTypeCode == data.flightType)
                    	vm.filteredSpecialRemarksTabData.push(data);
                });
            }
            else{
            	angular.forEach(vm.specialRemarksTabData, function(data) {
        			if (vm.filterByDepartment.code == data.department && vm.filterByFlightType.cabinFlightTypeCode == data.flightType){
        				vm.filteredSpecialRemarksTabData.push(data);
        			}
        		});
            }

        };

      function validateTargetSales() {
        if(vm.flightReportsTabData.targetAchieved && (angular.isUndefined(vm.flightReportsTabData.totalCateringSales)
          || angular.isUndefined(vm.flightReportsTabData.totalDutyFreeSales)
          || angular.isUndefined(vm.flightReportsTabData.totalOtherSalesAmount))){

          return false;
        }

        return true;
      }

        vm.pendingAdminRemarkFiles = [];

        vm.onAdminRemarkFileChange = function(input) {
          var files = Array.prototype.slice.call(input.files);
          if (!files.length) return;
          var allowed = ['jpg', 'jpeg', 'png', 'pdf'];
          var toAdd = [];
          for (var i = 0; i < files.length; i++) {
            var ext = files[i].name.split('.').pop().toLowerCase();
            if (allowed.indexOf(ext) === -1) {
              MessageService.error('Invalid file type: ' + files[i].name + '. Allowed: jpg, jpeg, png, pdf');
              input.value = '';
              return;
            }
            if (files[i].size > 3 * 1024 * 1024) {
              MessageService.error(files[i].name + ' exceeds 3MB limit.');
              input.value = '';
              return;
            }
            toAdd.push(files[i]);
          }
          $timeout(function() {
            vm.pendingAdminRemarkFiles = vm.pendingAdminRemarkFiles.concat(toAdd);
            input.value = '';
          });
        };

        vm.removeAdminRemarkFile = function(index) {
          vm.pendingAdminRemarkFiles.splice(index, 1);
        };

        vm.addSpecialRemarks = function() {
            if(!validateAddRemarks()){
              var filesToUpload = vm.pendingAdminRemarkFiles.slice();
              if (filesToUpload.length > 0) {
                var collectedNames = [];
                function uploadNext(index) {
                  if (index >= filesToUpload.length) {
                    pushRemark(collectedNames);
                    return;
                  }
                  var fd = new FormData();
                  fd.append('fileMeta', filesToUpload[index]);
                  cabinFlightAdminService.uploadRemarkImage(fd, function(res) {
                    if (res && res.success && res.data) collectedNames.push(res.data);
                    uploadNext(index + 1);
                  }, function() {
                    MessageService.error('Image upload failed. Please try again.');
                  });
                }
                uploadNext(0);
              } else {
                pushRemark([]);
              }
            }
        };

        function pushRemark(imageObjectNames) {
          var param = {
            "department": vm.model.selectedDepartment.code,
            "flightType": vm.model.selectedFlightType.cabinFlightTypeCode,
            "emailRecipients": vm.model.emailRecipients,
            "remarks": vm.model.specialRemark,
            "cabinFlightRemarksId": null,
            "cabinFlightReportId": vm.cabinFlightReportId,
            "crewTypeCode": null,
            "status": "ACT",
            "version": null,
            "feedbackExist": false,
            "feedback": null,
            "createdDate": moment().format(applicationConstants.SETTINGS.DATE_FORMAT),
            "createdTime": moment().format(applicationConstants.SETTINGS.TIME_FORMAT),
            "sno1": vm.model.sno1,
            "sno2": vm.model.sno2,
            "imageObjectNames": imageObjectNames
          };
          if (!vm.specialRemarksTabData) vm.specialRemarksTabData = [];
          if (!vm.filteredSpecialRemarksTabData) vm.filteredSpecialRemarksTabData = [];
          vm.specialRemarksTabData.push(param);
          vm.filteredSpecialRemarksTabData.push(param);
          vm.specialRemarksList.push(param);
          vm.model.specialRemark = "";
          vm.model.selectedDepartment = "";
          vm.model.selectedFlightType = "";
          vm.model.emailRecipients = "";
          vm.pendingAdminRemarkFiles = [];
        }

        function validateAddRemarks() {
          var error = false;

          if ((vm.model.specialRemark && vm.model.specialRemark.length == 0) ||(!vm.model.specialRemark)|| !vm.model.selectedFlightType || !vm.model.selectedDepartment) {
            MessageService.error("Flight type, deaprtment and feedback required");
            error = true;
          }
          if(vm.model.sno1Required && (vm.model.sno1 == null|| vm.model.sno1.length == 0)){
            MessageService.error("Serial number 1 is required");
            error = true;
          }

          if(vm.model.sno2Required && (vm.model.sno2 == null|| vm.model.sno2.length == 0)) {
            MessageService.error("Serial number 2 is required");
            error = true;
          }

          if(remarksAlreadyExistsForTheFtypeDep()){
            MessageService.error("Flight Type remarks for Department is already entered.");
            error = true;
          }

          return error;
        }

        function remarksAlreadyExistsForTheFtypeDep() {

        var alreadyExist = false;
          vm.specialRemarksList.forEach(function(remark) {
            if(!!vm.model.selectedDepartment && !!vm.model.selectedFlightType &&
              remark.department === vm.model.selectedDepartment.code && remark.flightType === vm.model.selectedFlightType.cabinFlightTypeCode){
              alreadyExist = true;
            }
          });
          return alreadyExist;
        }

        function getRemarkDTO(remark){
        	var param = {
                    "department": remark.department,
                    "flightType": remark.flightType,
                    "emailRecipients":remark.emailRecipients,
                    "remarks": remark.remarks,
                    "cabinFlightRemarksId": remark.cabinFlightRemarksId,
                    "cabinFlightReportId": remark.cabinFlightReportId,
                    "crewTypeCode": null,
                    "status": remark.status,
                    "version": remark.version,
                    "feedbackExist": remark.feedbackExist,
                    "feedback": remark.feedback,
                    "createdDate": remark.createdDate,
                    "createdTime": remark.createdTime,
                    "sno1":remark.sno1,
                    "sno2":remark.sno2,
                    "imageObjectNames": remark.imageObjectNames || []
                };
        	return param;
        }

        vm.toggleAttachments = function(flight) {
          flight._showAttachments = !flight._showAttachments;
        };

        vm.viewRemarkFile = function(objectName) {
          if (!objectName) return;
          cabinFlightAdminService.getRemarkImageUrl(objectName, function(response) {
            if (response.success && response.data) {
              window.open(response.data, '_blank');
            } else {
              var errMsg = (response.errors && response.errors.length > 0) ? response.errors[0] : 'Unable to retrieve file.';
              MessageService.error(errMsg);
            }
          }, function(error) {
            MessageService.error('Failed to retrieve file.');
          });
        };

        vm.downloadRemarkFile = function(objectName) {
          if (!objectName) return;
          cabinFlightAdminService.getRemarkImageUrl(objectName, function(response) {
            if (response.success && response.data) {
              var filename = objectName.split('/').pop();
              fetch(response.data)
                .then(function(res) { return res.blob(); })
                .then(function(blob) {
                  var objectUrl = URL.createObjectURL(blob);
                  var a = document.createElement('a');
                  a.href = objectUrl;
                  a.download = filename;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(objectUrl);
                });
            } else {
              var errMsg = (response.errors && response.errors.length > 0) ? response.errors[0] : 'Unable to download file.';
              MessageService.error(errMsg);
            }
          }, function(error) {
            MessageService.error('Failed to download file.');
          });
        };

        function adaptSpecialRemarksToSaveReqFormat(remarksList){
        	var remarks = [];
        	if(!!remarksList){
        		remarksList.forEach(function(remark) {
        			remarks.push(getRemarkDTO(remark));
				});
        	}
        	return remarks;
        }

        vm.addRemarks = function(type) {
            if (type == 'inBound') {
                if (vm.inboundRemarks) {
                    if (vm.flightReportsTabData.inBoundInfoCollection.remarks == null || vm.flightReportsTabData.inBoundInfoCollection.remarks == undefined || vm.flightReportsTabData.inBoundInfoCollection.remarks.length == 0) {
                        vm.flightReportsTabData.inBoundInfoCollection.remarks = "";
                        vm.flightReportsTabData.inBoundInfoCollection.remarks_copy = "";
                    }
                    if (vm.flightReportsTabData.inBoundInfoCollection.remarks.length == 0) {
                        vm.flightReportsTabData.inBoundInfoCollection.remarks = vm.inboundRemarks;
                        vm.flightReportsTabData.inBoundInfoCollection.remarks_copy = vm.inboundRemarks;
                    } else {
                        vm.flightReportsTabData.inBoundInfoCollection.remarks += "\n" + vm.inboundRemarks;
                        vm.flightReportsTabData.inBoundInfoCollection.remarks_copy += "\n" + vm.inboundRemarks;
                    }
                    vm.inboundRemarks = "";
                } else {
                    MessageService.error("Remarks required");
                }
            }
            if (type == 'outBound') {
                if (vm.outboundRemarks) {
                    if (vm.flightReportsTabData.outBoundInfoCollection.remarks == null || vm.flightReportsTabData.outBoundInfoCollection.remarks == undefined || vm.flightReportsTabData.outBoundInfoCollection.remarks.length == 0) {
                        vm.flightReportsTabData.outBoundInfoCollection.remarks = "";
                        vm.flightReportsTabData.outBoundInfoCollection.remarks_copy = "";
                    }
                    if (vm.flightReportsTabData.outBoundInfoCollection.remarks.length == 0) {
                        vm.flightReportsTabData.outBoundInfoCollection.remarks = vm.outboundRemarks;
                        vm.flightReportsTabData.outBoundInfoCollection.remarks_copy = vm.outboundRemarks;
                    } else {
                        vm.flightReportsTabData.outBoundInfoCollection.remarks += "\n" + vm.outboundRemarks;
                        vm.flightReportsTabData.outBoundInfoCollection.remarks_copy += "\n" + vm.outboundRemarks;
                    }
                    vm.outboundRemarks = "";
                } else {
                    MessageService.error("Remarks required");
                }
            }
        }

      vm.copyCrewId = function(crew) {

        if (!crew || !navigator.clipboard) return;
        vm.copiedCrewId = crew.crewId;
        navigator.clipboard.writeText(crew.displayName)
          .then(function() {
            console.log("Copied Crew ID:", crew.displayName);
            $timeout(function() {
              vm.copiedCrewId = null;
            }, 2000);
          })
          .catch(function(err) {
            console.error("Clipboard copy failed:", err);
          });
      };

        vm.addDelayReasons = function (flag) {
          if(flag === 'outbound'){
            if (!vm.flightReportsTabData.outBoundInfoCollection.cabinFlightDelayCollection) vm.flightReportsTabData.outBoundInfoCollection.cabinFlightDelayCollection = [];
            var param = {
              "delayCode": '',
              "delayMinutes": ''
            };
            vm.flightReportsTabData.outBoundInfoCollection.cabinFlightDelayCollection.push(param);
          } else if(flag === 'inbound'){
            if (!vm.flightReportsTabData.inBoundInfoCollection.cabinFlightDelayCollection) vm.flightReportsTabData.inBoundInfoCollection.cabinFlightDelayCollection = [];
            var param1 = {
              "delayCode": '',
              "delayMinutes": ''
            };
            vm.flightReportsTabData.inBoundInfoCollection.cabinFlightDelayCollection.push(param1);
          } else if(flag === 'intermediate'){
            angular.forEach(vm.flightReportsTabData.intGroundInfoCollection, function (intermediateFlights) {
              if (!intermediateFlights.cabinFlightDelayCollection) intermediateFlights.cabinFlightDelayCollection = [];
              var param2 = {
                "delayCode": '',
                "delayMinutes": ''
              };
              intermediateFlights.cabinFlightDelayCollection.push(param2);
            })
          }
        };

        function loadCrewRoles() {

            vm.outboundCPCrews = [];
            vm.outboundFOCrews = [];
            vm.outboundCCCSCrews = [];
            vm.inboundCCCSCrews = [];
            vm.outboundENCrews = [];
            vm.allOutboundCrewsInboundCCCScrews = [];
            vm.inboundFOCrews = [];
            vm.inboundSOCrews = [];
            vm.allOutboundCrewsInboundCPcrews = [];

            angular.forEach(vm.outBoundCrewCollection, function(crew) {
                crew.displayName = crew.name + "(" + crew.crewId + ")";
                vm.allOutboundCrewsInboundCCCScrews.push(crew);
                if (crew.crewType == "CP") {
                    vm.outboundCPCrews.push(crew);
                } else if (crew.crewType == "FO") {
                    vm.outboundFOCrews.push(crew);
                } else if (crew.crewType == "CC" || crew.crewType == "CS") {
                    vm.outboundCCCSCrews.push(crew);
                } else if (crew.crewType == "EN") {
                    vm.outboundENCrews.push(crew);
                }
            });

            vm.allOutboundCrewsInboundCPcrews = angular.copy(vm.allOutboundCrewsInboundCCCScrews);
            vm.allOutboundCrewsInboundCCCScrews = angular.copy(vm.allOutboundCrewsInboundCCCScrews);

            angular.forEach(vm.inBoundCrewCollection, function(crew) {
                crew.displayName = crew.name + "(" + crew.crewId + ")";
                if (crew.crewType == "SO") {
                    vm.inboundSOCrews.push(crew);
                } else if (crew.crewType == "FO") {
                    vm.inboundFOCrews.push(crew);
                } else if (crew.crewType == "CC" || crew.crewType == "CS") {
                    vm.allOutboundCrewsInboundCCCScrews.push(crew);
                    vm.inboundCCCSCrews.push(crew);
                } else if (crew.crewType == "CP") {
                    vm.allOutboundCrewsInboundCPcrews.push(crew);
                }
            })

            if(vm.outboundCCCSCrews.length == 0){
              vm.outboundCCCSCrews = angular.copy(vm.inboundCCCSCrews);
            }

            if (vm.allOutboundCrewsInboundCPcrews.length > 0) {
                vm.dutyTabData.InboundCapt.role = vm.allOutboundCrewsInboundCPcrews[0];
                vm.dutyTabData.InboundCapt.signIn = vm.allOutboundCrewsInboundCPcrews[0].checkInTime;
                vm.dutyTabData.InboundCapt.signOut = vm.allOutboundCrewsInboundCPcrews[0].checkOutTime;
            }
            if (vm.inboundFOCrews.length > 0) {
                vm.dutyTabData.InboundFO.role = vm.inboundFOCrews[0];
                vm.dutyTabData.InboundFO.signIn = vm.inboundFOCrews[0].checkInTime;
                vm.dutyTabData.InboundFO.signOut = vm.inboundFOCrews[0].checkOutTime;
            }
            if (vm.inboundSOCrews.length > 0) {
                vm.dutyTabData.InboundSO.role = vm.inboundSOCrews[0];
                vm.dutyTabData.InboundSO.signIn = vm.inboundSOCrews[0].checkInTime;
                vm.dutyTabData.InboundSO.signOut = vm.inboundSOCrews[0].checkOutTime;
            }
            if (vm.outboundCPCrews.length > 0) {
                vm.dutyTabData.Capt.role = vm.outboundCPCrews[0];
                vm.dutyTabData.Capt.signIn = vm.outboundCPCrews[0].checkInTime;
                vm.dutyTabData.Capt.signOut = vm.outboundCPCrews[0].checkOutTime;
            }
            if (vm.outboundFOCrews.length > 0) {
                vm.dutyTabData.FO.role = vm.outboundFOCrews[0];
                vm.dutyTabData.FO.signIn = vm.outboundFOCrews[0].checkInTime;
                vm.dutyTabData.FO.signOut = vm.outboundFOCrews[0].checkOutTime;
            }
            // set saved engineer data
            angular.forEach(vm.outboundENCrews, function(crew) {
                if (vm.dutyTabData.engineeringId) {
                    if (crew.crewProfileId == vm.dutyTabData.engineeringId) {
                        vm.dutyTabData.Engineering.role = crew;
                        vm.dutyTabData.Engineering.crewProfileId = crew.crewProfileId;
                        vm.dutyTabData.Engineering.signIn = crew.checkInTime;
                        vm.dutyTabData.Engineering.signOut = crew.checkOutTime;
                        vm.dutyTabData.Engineering.signInDelay = crew.signOutDelay;
                        vm.dutyTabData.Engineering.signOutDelay = crew.signOutDelay;
                        vm.dutyTabData.Engineering.name = crew.name;
                    }
                }
            });
            // set saved extracm data
            angular.forEach(vm.allOutboundCrewsInboundCCCScrews, function(crew) {
                if (vm.dutyTabData.extraCmId) {
                    if (crew.crewProfileId == vm.dutyTabData.extraCmId) {
                        vm.dutyTabData.ExtraCCM.role = crew;
                        vm.dutyTabData.ExtraCCM.crewProfileId = crew.crewProfileId;
                        vm.dutyTabData.ExtraCCM.signIn = crew.checkInTime;
                        vm.dutyTabData.ExtraCCM.signOut = crew.checkOutTime;
                        vm.dutyTabData.ExtraCCM.signInDelay = crew.signOutDelay;
                        vm.dutyTabData.ExtraCCM.signOutDelay = crew.signOutDelay;
                        vm.dutyTabData.ExtraCCM.name = crew.name;
                    }
                }
            });
            // set saved l1cs,r1cc,l4cc,r4cc and observer data
            angular.forEach(vm.outboundCCCSCrews, function(crew) {
                if (vm.dutyTabData.l1Cs) {
                    if (crew.crewProfileId == vm.dutyTabData.l1Cs) {
                        vm.dutyTabData.SCCML1.role = crew;
                        vm.dutyTabData.SCCML1.crewProfileId = crew.crewProfileId;
                        vm.dutyTabData.SCCML1.signIn = crew.checkInTime;
                        vm.dutyTabData.SCCML1.signOut = crew.checkOutTime;
                        vm.dutyTabData.SCCML1.signInDelay = crew.signOutDelay;
                        vm.dutyTabData.SCCML1.signOutDelay = crew.signOutDelay;
                    }
                }
                if (vm.dutyTabData.r1Cc) {
                    if (crew.crewProfileId == vm.dutyTabData.r1Cc) {
                        vm.dutyTabData.CCMR1.role = crew;
                        vm.dutyTabData.CCMR1.crewProfileId = crew.crewProfileId;
                        vm.dutyTabData.CCMR1.signIn = crew.checkInTime;
                        vm.dutyTabData.CCMR1.signOut = crew.checkOutTime;
                        vm.dutyTabData.CCMR1.signInDelay = crew.signOutDelay;
                        vm.dutyTabData.CCMR1.signOutDelay = crew.signOutDelay;
                    }
                }
                if (vm.dutyTabData.l4Cc) {
                    if (crew.crewProfileId == vm.dutyTabData.l4Cc) {
                        vm.dutyTabData.CCML4.role = crew;
                        vm.dutyTabData.CCML4.crewProfileId = crew.crewProfileId;
                        vm.dutyTabData.CCML4.signIn = crew.checkInTime;
                        vm.dutyTabData.CCML4.signOut = crew.checkOutTime;
                        vm.dutyTabData.CCML4.signInDelay = crew.signOutDelay;
                        vm.dutyTabData.CCML4.signOutDelay = crew.signOutDelay;
                    }
                }
                if (vm.dutyTabData.r4cCc) {
                    if (crew.crewProfileId == vm.dutyTabData.r4cCc) {
                        vm.dutyTabData.CCMR4C.role = crew;
                        vm.dutyTabData.CCMR4C.crewProfileId = crew.crewProfileId;
                        vm.dutyTabData.CCMR4C.signIn = crew.checkInTime;
                        vm.dutyTabData.CCMR4C.signOut = crew.checkOutTime;
                        vm.dutyTabData.CCMR4C.signInDelay = crew.signOutDelay;
                        vm.dutyTabData.CCMR4C.signOutDelay = crew.signOutDelay;
                    }
                }
                if (vm.dutyTabData.r3Cc) {
                  if (crew.crewProfileId == vm.dutyTabData.r3Cc) {
                    vm.dutyTabData.CCMR3.role = crew;
                    vm.dutyTabData.CCMR3.crewProfileId = crew.crewProfileId;
                    vm.dutyTabData.CCMR3.signIn = crew.checkInTime;
                    vm.dutyTabData.CCMR3.signOut = crew.checkOutTime;
                    vm.dutyTabData.CCMR3.signInDelay = crew.signOutDelay;
                    vm.dutyTabData.CCMR3.signOutDelay = crew.signOutDelay;
                  }
                }
                if (vm.dutyTabData.observerId) {
                    if (crew.crewProfileId == vm.dutyTabData.observerId) {
                        vm.dutyTabData.Checker.role = crew;
                        vm.dutyTabData.Checker.crewProfileId = crew.crewProfileId;
                        vm.dutyTabData.Checker.signIn = crew.checkInTime;
                        vm.dutyTabData.Checker.signOut = crew.checkOutTime;
                        vm.dutyTabData.Checker.signInDelay = crew.signOutDelay;
                        vm.dutyTabData.Checker.signOutDelay = crew.signOutDelay;
                        vm.dutyTabData.Checker.name = crew.name;
                    }
                }
            });
        }

        vm.setSelectedL1CsCrew = function() {
            if (vm.dutyTabData.SCCML1.role) {
                vm.dutyTabData.SCCML1.crewProfileId = vm.dutyTabData.SCCML1.role.crewProfileId;
                vm.dutyTabData.SCCML1.signIn = vm.dutyTabData.SCCML1.role.checkInTime;
                vm.dutyTabData.SCCML1.signOut = vm.dutyTabData.SCCML1.role.checkOutTime;
                vm.dutyTabData.SCCML1.signInDelay = vm.dutyTabData.SCCML1.role.signOutDelay;
                vm.dutyTabData.SCCML1.signOutDelay = vm.dutyTabData.SCCML1.role.signOutDelay;
            } else {
                vm.dutyTabData.SCCML1.signIn = "";
                vm.dutyTabData.SCCML1.signOut = "";
                vm.dutyTabData.SCCML1.crewProfileId = "";
                vm.dutyTabData.SCCML1.signInDelay = "";
                vm.dutyTabData.SCCML1.signOutDelay = "";
            }
        }

        vm.setSelectedR1CcCrew = function() {
            if (vm.dutyTabData.CCMR1.role) {
                vm.dutyTabData.CCMR1.signIn = vm.dutyTabData.CCMR1.role.checkInTime;
                vm.dutyTabData.CCMR1.signOut = vm.dutyTabData.CCMR1.role.checkOutTime;
                vm.dutyTabData.CCMR1.crewProfileId = vm.dutyTabData.CCMR1.role.crewProfileId;
                vm.dutyTabData.CCMR1.signInDelay = vm.dutyTabData.CCMR1.role.signOutDelay;
                vm.dutyTabData.CCMR1.signOutDelay = vm.dutyTabData.CCMR1.role.signOutDelay;
            } else {
                vm.dutyTabData.CCMR1.signIn = "";
                vm.dutyTabData.CCMR1.signOut = "";
                vm.dutyTabData.CCMR1.crewProfileId = "";
                vm.dutyTabData.CCMR1.signInDelay = "";
                vm.dutyTabData.CCMR1.signOutDelay = "";
            }
        }

        vm.setSelectedL4CcCrew = function() {
            if (vm.dutyTabData.CCML4.role) {
                vm.dutyTabData.CCML4.signIn = vm.dutyTabData.CCML4.role.checkInTime;
                vm.dutyTabData.CCML4.signOut = vm.dutyTabData.CCML4.role.checkOutTime;
                vm.dutyTabData.CCML4.crewProfileId = vm.dutyTabData.CCML4.role.crewProfileId;
                vm.dutyTabData.CCML4.signInDelay = vm.dutyTabData.CCML4.role.signOutDelay;
                vm.dutyTabData.CCML4.signOutDelay = vm.dutyTabData.CCML4.role.signOutDelay;
            } else {
                vm.dutyTabData.CCML4.signIn = "";
                vm.dutyTabData.CCML4.signOut = "";
                vm.dutyTabData.CCML4.crewProfileId = "";
                vm.dutyTabData.CCML4.signInDelay = "";
                vm.dutyTabData.CCML4.signOutDelay = "";
            }
        }

        vm.setSelectedR4cCcCrew = function() {
            if (vm.dutyTabData.CCMR4C.role) {
                vm.dutyTabData.CCMR4C.signIn = vm.dutyTabData.CCMR4C.role.checkInTime;
                vm.dutyTabData.CCMR4C.signOut = vm.dutyTabData.CCMR4C.role.checkOutTime;
                vm.dutyTabData.CCMR4C.crewProfileId = vm.dutyTabData.CCMR4C.role.crewProfileId;
                vm.dutyTabData.CCMR4C.signInDelay = vm.dutyTabData.CCMR4C.role.signOutDelay;
                vm.dutyTabData.CCMR4C.signOutDelay = vm.dutyTabData.CCMR4C.role.signOutDelay;
            } else {
                vm.dutyTabData.CCMR4C.signIn = "";
                vm.dutyTabData.CCMR4C.signOut = "";
                vm.dutyTabData.CCMR4C.crewProfileId = "";
                vm.dutyTabData.CCMR4C.signInDelay = "";
                vm.dutyTabData.CCMR4C.signOutDelay = "";
            }
        }

        vm.setSelectedR3CcCrew = function() {
          if (vm.dutyTabData.CCMR3.role) {
            vm.dutyTabData.CCMR3.signIn = vm.dutyTabData.CCMR3.role.checkInTime;
            vm.dutyTabData.CCMR3.signOut = vm.dutyTabData.CCMR3.role.checkOutTime;
            vm.dutyTabData.CCMR3.crewProfileId = vm.dutyTabData.CCMR3.role.crewProfileId;
            vm.dutyTabData.CCMR3.signInDelay = vm.dutyTabData.CCMR3.role.signOutDelay;
            vm.dutyTabData.CCMR3.signOutDelay = vm.dutyTabData.CCMR3.role.signOutDelay;
          } else {
            vm.dutyTabData.CCMR3.signIn = "";
            vm.dutyTabData.CCMR3.signOut = "";
            vm.dutyTabData.CCMR3.crewProfileId = "";
            vm.dutyTabData.CCMR3.signInDelay = "";
            vm.dutyTabData.CCMR3.signOutDelay = "";
          }
        };

        vm.setSelectedObserverCrew = function() {
            if (vm.dutyTabData.Checker.role) {
                vm.dutyTabData.Checker.signIn = vm.dutyTabData.Checker.role.checkInTime;
                vm.dutyTabData.Checker.signOut = vm.dutyTabData.Checker.role.checkOutTime;
                vm.dutyTabData.Checker.crewProfileId = vm.dutyTabData.Checker.role.crewProfileId;
                vm.dutyTabData.Checker.signInDelay = vm.dutyTabData.Checker.role.signOutDelay;
                vm.dutyTabData.Checker.signOutDelay = vm.dutyTabData.Checker.role.signOutDelay;
                vm.dutyTabData.Checker.name = vm.dutyTabData.Checker.role.name;
            } else {
                vm.dutyTabData.Checker.signIn = "";
                vm.dutyTabData.Checker.signOut = "";
                vm.dutyTabData.Checker.crewProfileId = "";
                vm.dutyTabData.Checker.signInDelay = "";
                vm.dutyTabData.Checker.signOutDelay = "";
                vm.dutyTabData.Checker.name = "";
            }
        }

        vm.setSelectedExtraCmCrew = function() {
            if (vm.dutyTabData.ExtraCCM.role) {
                vm.dutyTabData.ExtraCCM.signIn = vm.dutyTabData.ExtraCCM.role.checkInTime;
                vm.dutyTabData.ExtraCCM.signOut = vm.dutyTabData.ExtraCCM.role.checkOutTime;
                vm.dutyTabData.ExtraCCM.crewProfileId = vm.dutyTabData.ExtraCCM.role.crewProfileId;
                vm.dutyTabData.ExtraCCM.signInDelay = vm.dutyTabData.ExtraCCM.role.signOutDelay;
                vm.dutyTabData.ExtraCCM.signOutDelay = vm.dutyTabData.ExtraCCM.role.signOutDelay;
                vm.dutyTabData.ExtraCCM.name = vm.dutyTabData.ExtraCCM.role.name;
            } else {
                vm.dutyTabData.ExtraCCM.signIn = "";
                vm.dutyTabData.ExtraCCM.signOut = "";
                vm.dutyTabData.ExtraCCM.crewProfileId = "";
                vm.dutyTabData.ExtraCCM.signInDelay = "";
                vm.dutyTabData.ExtraCCM.signOutDelay = "";
                vm.dutyTabData.ExtraCCM.name = "";
            }
        }

        vm.setSelectedEngineeringCrew = function() {
            if (vm.dutyTabData.Engineering.role) {
                vm.dutyTabData.Engineering.signIn = vm.dutyTabData.Engineering.role.checkInTime;
                vm.dutyTabData.Engineering.signOut = vm.dutyTabData.Engineering.role.checkOutTime;
                vm.dutyTabData.Engineering.crewProfileId = vm.dutyTabData.Engineering.role.crewProfileId;
                vm.dutyTabData.Engineering.signInDelay = vm.dutyTabData.Engineering.role.signOutDelay;
                vm.dutyTabData.Engineering.signOutDelay = vm.dutyTabData.Engineering.role.signOutDelay;
                vm.dutyTabData.Engineering.name = vm.dutyTabData.Engineering.role.name;
            } else {
                vm.dutyTabData.Engineering.signIn = "";
                vm.dutyTabData.Engineering.signOut = "";
                vm.dutyTabData.Engineering.crewProfileId = "";
                vm.dutyTabData.Engineering.signInDelay = "";
                vm.dutyTabData.Engineering.signOutDelay = "";
                vm.dutyTabData.Engineering.name = "";
            }
        }

        vm.onChangeTargetSales = function(){
          vm.flightReportsTabData.totalTargetSales = Number(vm.flightReportsTabData.totalCateringSales)
            + Number(vm.flightReportsTabData.totalDutyFreeSales) + Number(vm.flightReportsTabData.totalOtherSalesAmount);
        }

        vm.changedDepartment =function () {
          vm.model.sno1Required = false;
          vm.model.sno2Required = false;
          vm.model.sno1 = null;
          vm.model.sno2 = null;

          if(!!vm.model.selectedFlightType && !!vm.model.selectedDepartment && vm.model.selectedDepartment.code ==="SKYTIME"){
            var flightDetails = getFlightDetais();

            if(flightDetails.sno1Required){
                vm.model.sno1Required = true;
            }

            if(flightDetails.sno2Required){
              vm.model.sno2Required = true;
            }

          }

        };

        function getFlightDetais() {
          if(vm.model.selectedFlightType.cabinFlightTypeCode === 'OUT'){
            return vm.flightReportsTabData.outBoundInfoCollection;
          }

          if(vm.model.selectedFlightType.cabinFlightTypeCode === 'IN'){
            return vm.flightReportsTabData.inBoundInfoCollection;
          }

          if(vm.model.selectedFlightType.cabinFlightTypeCode === 'INT'){
            return vm.flightReportsTabData.intGroundInfoCollection[1];
          }
        }

      function getCrewBase() {
        RemoteService.getBaseAirport().then(
          function (response) {
            if(response.success){
              vm.crewBaseEdit = response;
            }
          },
          function (error) {
            MessageService.error(error.msg[0]);
          });
      };

      vm.clickOnRemark = function(selectedRemark,flag,index) {
        console.log(selectedRemark);
        var details={
          "index":index,
          "cabinFlightRemarksId":selectedRemark.cabinFlightRemarksId,
          "cabinFlightReportId":selectedRemark.cabinFlightReportId,
          "department":selectedRemark.department,
          "emailRecipients":selectedRemark.emailRecipients,
          "feedback":selectedRemark.feedback,
          "flightType":selectedRemark.flightType,
          "remarks":selectedRemark.remarks
        }
        if(flag=='DELETE'){
          deleteCabinFlightRemark(details);
        }
      };

      function deleteCabinFlightRemark(details) {
        vm.selectedRemark = details;
        var details = {
          title: 'Confirmation',
          messages: [MessageService.MESSAGES.CABIN_FLIGHT_ADMIN.REMARK_DELETE_CONFIRMATION]
        };
        PopupManager.openModal('CONFIRM_DIALOG', details, confirmDeletion);
      }
      function confirmDeletion(pass){
        if(pass=='YES'){
          vm.filteredSpecialRemarksTabData.splice(vm.selectedRemark.index,1);
          vm.specialRemarksList.splice(vm.selectedRemark.index,1);
        }
      }
    }
}());
